import { render, staticRenderFns } from "./MicrosoftAdminOauthSettings.vue?vue&type=template&id=c4f68888"
import script from "./MicrosoftAdminOauthSettings.vue?vue&type=script&lang=js"
export * from "./MicrosoftAdminOauthSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports